import {
  applyMiddleware, combineReducers, compose, createStore,
} from 'redux';
import {createTransform, persistReducer, persistStore} from 'redux-persist';
import thunk from 'redux-thunk';
import storage from "redux-persist/lib/storage";
import * as  _ from "lodash";
import { authReducers } from "./Components/Auth";


// Strip transient error fields from the auth slice before redux-persist
// writes it to localStorage. Without this, AUTH_FAIL's `error` + `errorAt`
// timestamp are rehydrated on every page load, and Login.js's toast effect
// (which depends on authErrorAt) would fire on app boot showing a phantom
// red toast for a failed login that happened in a prior session.
// Note: the slice key from combineReducers is 'adminUser' (not 'auth') and
// the slice itself contains a nested `adminUser` object (the reducer's own
// initialState shape), so the path to strip is adminUser.error / adminUser.errorAt.
const blacklistTransform = createTransform((inboundState: any, key) => {
  if (key === 'adminUser' && inboundState && inboundState.adminUser) {
    return {
      ...inboundState,
      adminUser: _.omit(inboundState.adminUser, ['error', 'errorAt']),
    };
  }
  return inboundState;
});

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: ['events'],
  transforms: [blacklistTransform],
  version: 2,
};

const rootReducer = combineReducers({
  adminUser: authReducers,
})

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
// eslint-disable-next-line max-len
// const composeEnhances = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhances =  compose;


const store = createStore(
    persistedReducer, composeEnhances(applyMiddleware(thunk)),
);
const persistor = persistStore(store);

export {
  store,
  persistor,
};
